<template>
  <div>
    <div class="w1200">
      <Quicklink></Quicklink>
      <div class="new-main">
        <div class="news-content">
          <div class="new-l">
            <img
              style="padding: 20px 0;"
              src="./../assets/img/information_title.png"
              alt=""
            />
            <Carousel
              autoplay
              v-model="value2"
              class="planting"
              :autoplay-speed="3000"
            >
              <CarouselItem v-for="item in this.news.right" :key="item.Id">
                <div
                  class="news-item"
                  @click="goNewsDetail(item.Id)"
                  style="cursor: pointer"
                >
                  <img class="newsimg" :src="item.ImgUrl" alt srcset />
                  <div class="jxnewtext">
                    <div class="title">{{ item.Title }}</div>
                    <!-- <div class="content" v-html="item.Content"></div> -->
                    <div class="pubtime">
                      <div>{{ item.PublishTime }}</div>
                      <div class="xq" @click="goNewsDetail(item.Id)">
                        查看详情>
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>
            </Carousel>
            <div class="new-l-box">
              <div
                class="new-l-list"
                v-for="item in this.news.left"
                :key="item.Id"
                @click="goNewsDetail(item.Id)"
                style="cursor: pointer"
              >
                <div class="title"><span></span>{{ item.Title }}</div>
                <div class="publishtime">{{ item.PublishTime }}</div>
              </div>
            </div>
            <div class="look-more" style="bottom: 0px;" @click="newsMore"></div>
          </div>
          <div class="new-left">
            <div class="box-title">
              <img src="../assets/img/notice-title.png" alt="" />
              <!-- <div class="more" @click="goInitiatives" >查看更多&gt;&gt;</div> -->
            </div>
            <div
              class="new-list"
              v-for="item in MeasureData"
              :key="item.Id"
              @click="goMeasureDetaill(item.Id)"
              style="cursor: pointer"
            >
              <div class="new-time">
                <p class="year">{{ item.PublishTime.slice(0, 7) }}</p>
                <p class="day">{{ item.PublishTime.slice(8, 10) }}</p>
              </div>
              <div class="new-list-left">
                <h3 class="title">
                  <span class="xian"></span> {{ item.Title }}
                </h3>
                <!-- v-html="item.Content" -->
                <div class="text" v-html="item.Content"></div>
                <!-- <p class="text" >{{item.Content}}</p> -->
              </div>
            </div>
          </div>
          <div class="look-more" @click="goInitiatives"></div>
        </div>
      </div>

      <div class="notice-mian">
        <!-- <div class="notice-box" >
          <div class="box-title">
           <img src="../assets/img/notice-title.png" alt="">
           <div class="more" @click="goInitiatives" >查看更多&gt;&gt;</div>
           </div>
          <div class="notice-box0">
            <div class="not-list" v-for="(item,index) in MeasureData" :key="index" @click="goMeasureDetaill(item.Id)">
              <div class="title">{{item.Title}}</div>
              <div class="time">{{item.PublishTime}}</div>
              <div class="text" v-html="item.Content"></div>
            </div>
          </div>
        </div> -->
        <div>
          <div class="box-title">
            <img src="../assets/img/jgxxgs.png" alt="" />
            <div
              class="more"
              v-if="this.datadisplacementofDam.length > 0"
              @click="TongGuoList"
            >
              查看更多&gt;&gt;
            </div>
          </div>
          <OrganInfo></OrganInfo>
          <!-- <div class="scroll-boxsd">
            <div v-if="this.datadisplacementofDam.length > 0">
              <dv-scroll-board
                :rowNum="12"
                :config="configdisplacementofDam"
                style="width: 100%; height: 480px"
              />
            </div>
            <div v-else>
              <img src="../assets/img/zw.png" alt="" />
            </div>
          </div> -->
        </div>
        <Query></Query>
      </div>
      <div class="pol_down-main">
        <div class="policy">
          <div class="box-title">
            <img src="../assets/img/policy_title.png" alt="" />
            <div class="more" @click="ZhengCe">查看更多>></div>
          </div>
          <div class="policy-box">
            <div
              class="policy-list"
              v-for="(item, index) in formanceData"
              :key="index"
              @click="goenterprisedetail(item.Id)"
            >
              <span class="dot"></span>
              <div class="title">{{ item.Title }}</div>
              <div class="time">{{ item.PublishTime }}</div>
            </div>
          </div>
        </div>
        <div class="datadown">
          <div class="box-title">
            <img src="../assets/img/datadown_title.png" alt="" />
            <div class="more" @click="Uploads">查看更多>></div>
          </div>
          <div class="datadown-box">
            <ul class="tab-tit">
              <li
                v-for="(title, index) in tabTitle"
                @click="cur = index"
                :class="{ active: cur == index }"
                :key="index"
              >
                <span>{{ title }}</span>
              </li>
            </ul>
            <div class="tab-content">
              <div v-show="cur == 1">
                <div
                  class="datadown-list"
                  v-for="(item, index) in Upload.left"
                  @click="goUploadInfo(item.Id)"
                  :key="index"
                >
                  <span class="dot"></span>
                  <div class="title">{{ item.Title }}</div>
                  <div class="time">{{ item.PublishTime }}</div>
                </div>
              </div>

              <div v-show="cur == 0">
                <div
                  class="datadown-list"
                  v-for="(item, index) in Upload.right"
                  @click="goUploadInfo(item.Id)"
                  :key="index"
                  v-if="index < 4"
                >
                  <span class="dot"></span>
                  <div class="title">{{ item.Title }}</div>
                  <div class="time">{{ item.PublishTime }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ContactUs></ContactUs>
      <Link></Link>
      <div class="help">
        <div class="help-list help-list1" @click="helpPage()">
          <div class="icon1"></div>
          <p>帮助中心</p>
        </div>
        <div class="line"></div>
        <div class="help-list help-list2" @click="answerPage()">
          <div class="icon2"></div>
          <p>问题答疑</p>
        </div>
      </div>
    </div>

    <!-- <div class="box"> -->
    <!-- <div class="leftfexd">
        <img style="width:230px" src="../assets/img/imptz.png" alt="" srcset="">
        <div class="text-content">
          <div class="title">{{ZhongYao.Title}}</div>
          <div class="text">{{ZhongYao.Content}}</div>
        </div>
      </div> -->
    <!-- <floatView v-if="showView"  :json="json" @closeView="closeView"></floatView> -->
  </div>

  <!-- </div> -->
</template>
<style>
/* .box{

        width: 230px;
        height: 312px;
        border: 1px solid red;
        position: fixed;
        top: 0;
        left: 0;

    } */
</style>
<style lang="less">
@import url("./../assets/css/main.less");
</style>
<script>
import { getNewsHomeData, GetTongGuo } from "@/api/news";
import { getMeasureHomeData } from "@/api/measure";
import { getPosterHomeData } from "@/api/poster";
import { getPerformanceHomeData } from "@/api/performance";
import Quicklink from "../components/quicklink";
import ContactUs from "../components/Contactus";
import Link from "../components/link";
import Query from "../components/query";
import floatView from "../components/floatlayer";
import OrganInfo from "../components/organInfo";
export default {
  components: {
    Quicklink,
    ContactUs,
    Link,
    Query,
    floatView,
    OrganInfo
  },
  data() {
    return {
      value2: 0,
      ZhongYao: {
        Title: "",
        Content: ""
      },
      news: {
        left: [],
        right: []
      },
      Upload: {
        left: [],
        right: []
      },
      formanceData: [],
      MeasureData: [],
      tabTitle: ["资料下载", "表格下载"],

      cur: 0,
      measureList: [],
      posterList: [],
      json: {
        left: 100,
        top: 400,
        directionX: 1,
        directionY: 1,
        distance: null,
        interval: null,
        target: null,
        zIndex: 9999,
        width: null,
        height: null,
        noHoverPause: null, //鼠标经过时不停止，为true时不停止
        cursor: null
      },
      showView: true,
      headerdisplacementofDam: ["省份", "市", "单位名称", "单位地址", "状态"],
      datadisplacementofDam: [],
      configdisplacementofDam: {}
    };
  },
  methods: {
    TongGuoList() {
      window.open("http://jxedu.zhujianpeixun.com/", "_blank");
    },
    newsMore() {
      // this.$router.push({ path: '/news', query: { }})
      this.$router.push({ path: "/news", query: {} });
      this.showView = false;
      window.scrollTo(0, 0);
      // window.open(detail.href, "_blank");
    },
    ZhengCe() {
      this.$router.push({ path: "/enterprise", query: {} });
      this.showView = false;
      // window.open(detail.href, "_blank");
      window.scrollTo(0, 0);
    },
    Uploads() {
      this.$router.push({ path: "/actionposter", query: {} });
      this.showView = false;
      window.scrollTo(0, 0);
    },
    goInitiatives() {
      this.$router.push({ path: "/initiatives", query: {} });
      this.showView = false;
      window.scrollTo(0, 0);
    },
    //新闻数据
    getNewsData() {
      var _this = this;
      getNewsHomeData().then(res => {
        if (res.success) {
          _this.news.right = res.data.slice(0, 3);
          _this.news.left = res.data.slice(3, 6);
        }
      });
    },

    // 资料/表格
    getPosterData() {
      var _this = this;
      getPosterHomeData().then(res => {
        if (res.success) {
          _this.Upload.left = res.data.filter(s => s.Type === 1).slice(0, 5);
          _this.Upload.right = res.data.filter(s => s.Type === 2).slice(0, 5);
          console.log(_this.Upload);
        }
      });
    },
    //通知公告
    getMeasureData() {
      var _this = this;
      getMeasureHomeData().then(res => {
        if (res.success) {
          _this.MeasureData = res.data.slice(0, 4);
        }
      });
    },
    getPerformanceData() {
      var _this = this;
      getPerformanceHomeData().then(res => {
        if (res.success) {
          this.formanceData = res.data;
        }
      });
    },
    closeView(val) {
      this.showView = false;
    },
    goUploadInfo(id) {
      this.$router.push({
        path: "/actionposterdetail",
        query: { id: id }
      });
      this.showView = false;
      window.scrollTo(0);
    },
    goNewsDetail(id) {
      // this.$router.push({ path: '/newsdetail', query: { 'id': id }})
      this.$router.push({
        path: "/newsdetail",
        query: { id: id }
      });
      this.showView = false;
      window.scrollTo(0);
    },
    goMeasureDetaill(id) {
      this.$router.push({
        path: "/initiativesdetail",
        query: { id: id }
      });
      this.showView = false;
      window.scrollTo(0);
    },
    goenterprisedetail(id) {
      this.$router.push({
        path: "/enterprisedetail",
        query: { id: id }
      });
      this.showView = false;
      window.scrollTo(0);
    },
    gundong() {
      GetTongGuo().then(res => {
        this.datadisplacementofDam = res.data;
        this.configdisplacementofDam = {
          data: this.datadisplacementofDam, // 表数据
          // data:res.data,
          header: this.headerdisplacementofDam, // 表头数据
          rowNum: 11, // 表行数
          headerBGC: "#C62127", // 表头背景色
          oddRowBGC: "#f2f2f7", // 奇数行背景色
          evenRowBGC: "#f8d9da", // 偶数行背景色
          waitTime: 3000, // 轮播时间间隔(ms)
          align: "center"
        };
      });
    },
    helpPage() {
      this.$router.push({
        path: "/help"
      });
    },
    answerPage() {
      this.$router.push({
        path: "/answer"
      });
    }
  },
  mounted() {
    this.getNewsData();
    this.getMeasureData();
    this.getPerformanceData();
    this.getPosterData();
    // this.gundong();

    // GetTongGuo().then(res => {
    //   console.log('111');
    // })
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/index.vue